export default {
    en: {
        answers: '"left brain” skills left-hemispheres',
        interactiveBoxNumber: [1],
        number: 6,
        diagramId: 5,
        blocks:
            [
                {
                    task: {
                        question: 'Early childhood teaching focuses on developing the “left brain” skills of reading, writing and ‘rithmatic',
                        answer: '<span class="correct-answer-box">Early childhood teaching focuses on developing the <span class="highlight__answer highlight__answer_correct highlight__answer_correct_6">"left brain” skills</span> of reading, writing and ‘rithmatic</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'But scientists have recorded striking changes in the left-hemispheres of children who have had only a single year of violin',
                        answer: '<span class="correct-answer-box">But scientists have recorded striking changes in the <span class="highlight__answer highlight__answer_correct highlight__answer_correct_6">left-hemispheres</span> of children who have had only a single year of violin</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'Music may be every bit as important educationally as reading or writing',
                        answer: '<span class="correct-answer-box">Music may be every bit as important educationally as reading or writing</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise6.js